import { createStore, compose, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import { fromJS } from 'immutable';
import reducers from './reducers';

export function configureStore(preloadedState) {
  let middlewares = applyMiddleware(reduxThunk);

  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    const reduxDevToolsComposer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    middlewares = reduxDevToolsComposer(applyMiddleware(reduxThunk));
  }

  return createStore(reducers, fromJS(preloadedState), middlewares);
}
